








import { defineComponent, PropType } from '@vue/composition-api';
import BidSet from '../set/index.vue';
import { CurrencyOption } from './../../../../hooks/creation/account/useCurrencyOption/index';

const name = 'ttam-bid-strategy-deep-bid-set';

export default defineComponent({
  name,
  components: {
    BidSet,
  },
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    validateStatus: {
      type: String,
      default: 'default',
    },
    inputType: {
      type: String,
      default: 'number',
    },
    currencyUnit: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dataKey: {
      type: String,
      default: '',
    },
    currencyOption: {
      type: Object as PropType<CurrencyOption>,
      default: () => ({}),
    },
  },
  setup() {
    return {
      name,
    };
  },
});
